import { Loading } from 'pages/loading/ui/loading.page';
import React from 'react';
import { useParams } from 'react-router-dom';
import { PageLayout } from 'shared/ui';
import { CustomerCalendarCard, Header } from 'widgets';

export const CustomerCreateBookingPage: React.FC = () => {
  const { pointId } = useParams();

  return pointId ? (
    <PageLayout>
      <Header hideActions />
      <CustomerCalendarCard />
    </PageLayout>
  ) : (
    <Loading />
  );
};
